module.exports = __webpack_public_path__ + "static/img/womanAsa.73b32d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HumanPic/womanAsa.png
// module id = kJsO
// module chunks = 2